var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from "react";
import ListView from "./ListView";
import Loader from "./Loader";
import { withToast } from "../HOC/Toast";
import Box from "./Box";
import { shallowEqual } from "../util/compare";
import { errorToString } from "../index";
import TextInput from "./TextInput";
var ManagedListView = /** @class */ (function (_super) {
    __extends(ManagedListView, _super);
    function ManagedListView(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            loading: true
        };
        _this.renderPager = _this.renderPager.bind(_this);
        return _this;
    }
    ManagedListView.prototype.reload = function () {
        this.load(0);
    };
    ManagedListView.prototype.componentDidMount = function () {
        this.load(0);
    };
    ManagedListView.prototype.componentDidUpdate = function (prevProps) {
        if (prevProps.contentType != this.props.contentType || !shallowEqual(prevProps.apiFilter, this.props.apiFilter) || prevProps.apiFunc != this.props.apiFunc || !shallowEqual(prevProps.extraData, this.props.extraData))
            this.load(0);
    };
    ManagedListView.prototype.load = function (retry, page) {
        var _this = this;
        if (page === void 0) { page = 'first'; }
        this.setState({ loading: true, albums: undefined });
        var skip = 0;
        if (this.state.pagingInfo && page != 'first') {
            if (page == 'prev') {
                if (this.state.pagingInfo.page > 1)
                    skip = (this.state.pagingInfo.page - 2) * this.props.limit;
            }
            else if (page == 'next') {
                skip = this.state.pagingInfo.page * this.props.limit;
            }
            else if (page == 'last') {
                skip = (this.props.limit * (Math.ceil(this.state.pagingInfo.total / this.props.limit) - 1));
            }
            else if (!Number.isNaN(page)) {
                skip = this.props.limit * (page - 1);
            }
        }
        var currentFilter = this.props.apiFilter;
        this.props.apiFunc(this.props.contentType, Object.assign({}, this.props.apiFilter), { limit: this.props.limit, skip: skip }).then(function (_a) {
            var albums = _a.data, pagination = _a.pagination;
            if (!shallowEqual(currentFilter, _this.props.apiFilter)) {
                return;
            }
            _this.setState({ albums: albums, pagingInfo: pagination, loading: false });
            window.scrollTo(0, 0);
        }).catch(function (error) {
            if (retry >= 2) {
                errorToString(error).forEach(function (error) {
                    _this.props.showToast('danger', error, function () {
                        _this.load(0, page);
                    });
                });
                _this.props.onError && _this.props.onError(error);
            }
            else {
                setTimeout(function () {
                    _this.load(retry + 1, page);
                }, 1500);
            }
        });
    };
    ManagedListView.prototype.calculatePagination = function (current, last, moreSymbol) {
        var delta = 1, left = current - delta, right = current + delta + 1, range = [], rangeWithDots = [], l;
        for (var i = 1; i <= last; i++) {
            if (i == 1 || i == last || i >= left && i < right) {
                range.push(i);
            }
        }
        for (var _i = 0, range_1 = range; _i < range_1.length; _i++) {
            var i = range_1[_i];
            if (l) {
                if (i - l === 2) {
                    rangeWithDots.push(l + 1);
                }
                else if (i - l !== 1) {
                    rangeWithDots.push(moreSymbol);
                }
            }
            rangeWithDots.push(i);
            l = i;
        }
        return rangeWithDots;
    };
    ManagedListView.prototype.renderPager = function () {
        var _this = this;
        if (this.state.pagingInfo && !this.props.disablePaging) {
            var moreSymbol_1 = Symbol('More');
            var endNumber_1 = Math.ceil(this.state.pagingInfo.total / this.props.limit);
            var current_1 = this.state.pagingInfo.page;
            var paginationArray = endNumber_1 != 1 ? this.calculatePagination(current_1, endNumber_1, moreSymbol_1) : [];
            return (React.createElement("ul", { className: 'pagination' },
                current_1 > 1 && React.createElement(React.Fragment, null,
                    React.createElement("li", null,
                        React.createElement("a", { href: "javascript:void(0)", onClick: function () { return _this.load(0, 'first'); } },
                            React.createElement("span", { "aria-hidden": "true" }, "\u00AB"))),
                    React.createElement("li", null,
                        React.createElement("a", { href: "javascript:void(0)", onClick: function () { return _this.load(0, 'prev'); } },
                            React.createElement("span", { "aria-hidden": "true" }, "\u2039")))),
                paginationArray.map(function (item, index) {
                    return React.createElement("li", { key: index, className: (item != moreSymbol_1 && item == current_1) ? 'selected' : ((item == moreSymbol_1) ? 'more' : '') },
                        React.createElement("a", { href: item == moreSymbol_1 ? undefined : "javascript:void(0)", onClick: item == moreSymbol_1 ? undefined : (function () { return _this.load(0, item); }) },
                            React.createElement("span", { "aria-hidden": "true" }, item == moreSymbol_1 ? '…' : item)));
                }),
                current_1 < endNumber_1 && React.createElement(React.Fragment, null,
                    React.createElement("li", null,
                        React.createElement("a", { href: "javascript:void(0)", onClick: function () { return _this.load(0, 'next'); } },
                            React.createElement("span", { "aria-hidden": "true" }, "\u203A"))),
                    React.createElement("li", null,
                        React.createElement("a", { href: "javascript:void(0)", onClick: function () { return _this.load(0, 'last'); } },
                            React.createElement("span", { "aria-hidden": "true" }, "\u00BB")))),
                endNumber_1 > 1 && React.createElement("li", { className: "input" },
                    React.createElement(TextInput, { className: "page-input", defaultValue: current_1.toString(), accept: 'number', min: 1, max: endNumber_1, onKeyPress: function (e) {
                            if (e.key == 'Enter') {
                                var i = parseInt(e.currentTarget.value);
                                if ((!Number.isNaN(i)) && i >= 1 && i <= endNumber_1) {
                                    _this.load(0, i);
                                }
                            }
                            else {
                                var charCode = (e.which) ? e.which : e.keyCode;
                                if ((charCode < 48 || charCode > 57)) {
                                    e.preventDefault();
                                    return false;
                                }
                            }
                            return true;
                        } }))));
        }
        return null;
    };
    ManagedListView.prototype.render = function () {
        if (this.state.loading) {
            return React.createElement(Loader, null);
        }
        else if (this.state.albums && this.state.albums.length > 0) {
            return React.createElement(ListView, __assign({ renderPager: this.renderPager }, this.props, { albums: this.state.albums }));
        }
        return React.createElement(Box, null,
            React.createElement("p", { style: { textAlign: 'center' } }, this.props.noAlbumsText || ''));
    };
    ManagedListView.defaultProps = {
        limit: 20
    };
    return ManagedListView;
}(React.Component));
export default withToast(ManagedListView);
//# sourceMappingURL=ManagedListView.js.map


//////////////////
// WEBPACK FOOTER
// ./bpm-web-generic/lib/components/ManagedListView.js
// module id = 1287
// module chunks = 0